module.exports = __webpack_public_path__ + "static/media/English-Language-Flag.ad726c52.png";